import React, { useEffect, useRef, useState } from 'react';
import Tesseract from 'tesseract.js';

const App = () => {
	const outputRef = useRef(null);
	const [output, setOutput] = useState(null);
	const [isFetching, setIsFetching] = useState(false);
	const [isCopied, setIsCopied] = useState(false);

	const handleUpload = async (file, language) => {
		setIsFetching(true);
		try {
			const result = await Tesseract.recognize(file, language);
			setOutput(result.data.text);
		} catch (error) {
			setOutput('Error occured: ', error);
		} finally {
			setIsFetching(false);
		}
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		const formData = new FormData(event.target);
		const file = formData.get('image');
		const language = formData.get('language') || 'deu';

		if (file) {
			setOutput(null);
			setIsCopied(false);
			handleUpload(file, language);
		}
	};

	useEffect(() => {
		if (output && outputRef) {
			outputRef.current.innerText = output;
		}
	}, [output]);

	return (
		<>
			<div className='container'>
				<div className='row'>
					<div className='col-12'>
						<div className='d-flex flex-column align-items-center py-5'>
							<h1 className='title fw-bolder'>Transform Images to Text with</h1>
							<h1 className='orange-gradient title my-2 fw-bold'>SnapText</h1>

							<form onSubmit={handleSubmit} className='mt-4'>
								<div>
									<label
										htmlFor='form-file'
										className='w-100 form-label text-center'>
										Choose an image to extract text from
									</label>
									<input
										className='form-control form-control-lg'
										id='form-file'
										type='file'
										name='image'
										accept='image/*'
										required
									/>
								</div>

								<label className='w-100 form-label text-center mt-2' htmlFor='form'>
									Select the language of the text
								</label>
								<select id='form' className='form-select' name='language'>
									<option value='deu' defaultValue>
										🇩🇪 German
									</option>
									<option value='eng'>🇬🇧 English</option>
									<option value='rus'>🇷🇺 Russian</option>
									<option value='ukr'>🇺🇦 Ukrainian (bless you god)</option>
								</select>

								<div className='d-flex justify-content-center mt-3'>
									<button
										className={`${
											isFetching && 'disabled'
										} btn green-bg-color text-white fw-semibold px-4 py-3 py-md-2`}
										type='submit'>
										Get Text
									</button>
								</div>
							</form>

							<div className='mt-4'>
								{isFetching ? (
									<i className='fa-solid fa-spinner fa-spin-pulse fa-xl'></i>
								) : (
									output && (
										<div className='output-field secondary-bg-color p-4 pt-3 rounded-3'>
											<div className='d-flex justify-content-between align-items-center'>
												<h5 className='blue-color my-0'>Recognized text</h5>
												<button
													className={`${
														isCopied && 'disabled'
													} btn tertiary-bg-color fw-semibold px-4 py-2`}
													onClick={() => {
														navigator.clipboard.writeText(output);
														setIsCopied(true);
													}}>
													{isCopied ? 'Copied!' : 'Copy'}
												</button>
											</div>
											<div ref={outputRef} className='mt-2'></div>
										</div>
									)
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default App;
